import React from 'react'
import PeriodFilterBlock from './PeriodFilterBlock'
import Loader from './Loader'
import LineChart from './LineChart'

const LineChartBlock = ({ periodFilters, isLoading, state }) => {
  return (
    <>
      <div className='currency-chart-ma__period-filters'>
        <p className='currency-chart-ma__period-filters-text'>Период:</p>
        {periodFilters.map((item, index) => {
          return <PeriodFilterBlock {...{ ...item, periodFilters }} key={index} />
        })}
      </div>
      <div className='currency-chart-ma__line-chart-block'>
        {isLoading && <Loader />}
        {!isLoading && state.chartData && state.todayData &&
          <LineChart chartData={state.chartData} todayData={state.todayData} />}
      </div>
    </>
  )
}

export default LineChartBlock
